import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { postItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import {
  RemissionNote,
  formatRemissionNoteNumber,
} from "../../models/remission-note";

interface RemissionNoteConsultByCdcModalProps {
  show: boolean;
  remissionNote?: RemissionNote;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const RemissionNoteConsultByCdcModal: React.FC<
  RemissionNoteConsultByCdcModalProps
> = ({ show, remissionNote, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = remissionNote
    ? `Está seguro de que quiere consultar la nota de remisión ${formatRemissionNoteNumber(
        remissionNote
      )} por CDC?`
    : "";

  const onConsultClick = async () => {
    if (remissionNote !== undefined) {
      setSubmitting(true);
      const status = await postItem(
        `/remission_notes/${remissionNote.id}/consult_by_cdc/`,
        {}
      );

      if (status.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (status.detail !== undefined) {
          message = status.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-primary" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Consultar por CDC</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onConsultClick} color="primary">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Consultando..." : "Consultar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default RemissionNoteConsultByCdcModal;
